"use client";

// DeeperInsightsCTA moved to @/components/matching/ so the shared
// MatchingResultsPanel (inline tool + /match/<id> share surface) can use it.
export { DeeperInsightsCTA } from "@/components/matching/DeeperInsightsCTA";

// ── MatchingSeoContent ─────────────────────────────────────────────────────────

export function MatchingSeoContent() {
  return (
    <div className="mt-12 card-sacred p-6 sm:p-8">
      <h2 className="text-[20px] font-bold mb-4 text-ish-dark font-serif">
        What is Kundli Matching (Gun Milan)?
      </h2>
      <div className="space-y-3 text-[14px] leading-relaxed text-ish-text-muted">
        <p>
          <strong className="text-ish-dark">Kundli Matching</strong> (also called Gun Milan or
          Horoscope Matching) is a Vedic astrology practice used to assess compatibility between two
          people for marriage. The traditional Ashtakoot system evaluates 8 different aspects
          (kootas) worth a total of 36 points (Gunas).
        </p>
        <p>
          The 8 kootas are: <strong className="text-ish-dark">Varna</strong> (spiritual
          compatibility, 1 point), <strong className="text-ish-dark">Vashya</strong> (mutual
          influence, 2 points), <strong className="text-ish-dark">Tara</strong> (birth star
          compatibility, 3 points), <strong className="text-ish-dark">Yoni</strong> (physical
          compatibility, 4 points), <strong className="text-ish-dark">Graha Maitri</strong>{" "}
          (planetary friendship, 5 points), <strong className="text-ish-dark">Gana</strong>{" "}
          (temperament, 6 points), <strong className="text-ish-dark">Bhakoot</strong> (emotional
          compatibility, 7 points), and <strong className="text-ish-dark">Nadi</strong> (health and
          genes, 8 points).
        </p>
        <p>
          A score of <strong className="text-ish-dark">18 or above</strong> out of 36 is generally
          considered acceptable for marriage. Scores above 25 indicate very good compatibility,
          while 33+ is considered excellent. Mangal Dosha (Mars affliction) is also checked
          separately as it can affect marital harmony.
        </p>
      </div>
    </div>
  );
}
